// frontend/src/routes/AdminRoute.js

import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';

/**
 * A private route that only allows access to users with System Admin or Internal Supervisor roles.
 * It handles authentication state and redirects unauthorized users.
 * @param {object} children The child components to render if the user is authorized.
 */
const AdminRoute = ({ children }) => {
  const { 
    isAuthenticated, 
    initialized, 
    hasRole,
    hasPermission,
    PERMISSION_LEVELS 
  } = useAuth();

  // Show a loading screen while the authentication state is being determined.
  if (!initialized) {
    return <div className="loading-screen">Loading authentication...</div>;
  }

  // If the user is not authenticated, redirect them to the login page.
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin permissions using either role check or permission check
  const isAdmin = hasRole(['SYSTEM_ADMIN', 'INTERNAL_SUPERVISOR']) || 
                  hasPermission('settings', 'edit', PERMISSION_LEVELS.ALL);

  // If the user does not have admin access, redirect them to the dashboard.
  if (!isAdmin) {
    console.warn("Unauthorized access attempt to AdminRoute. Redirecting to dashboard.");
    return <Navigate to="/dashboard" replace />;
  }

  // If the user is authenticated and has admin access, render the child components.
  return children;
};

export default AdminRoute;